import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ReactMarkdown from 'react-markdown';

interface HoroscopeResultProps {
  result: string;
  type: string;
  onReset: () => void;
}

const HoroscopeResult: React.FC<HoroscopeResultProps> = ({ result, type, onReset }) => {
  return (
    <Box mt={1} position="relative">
      <Typography variant="h6" color="white">הורוסקופ {type}:</Typography>
      <Typography 
        sx={{ 
          textAlign: 'justify', 
          color: 'white', 
          fontWeight: 400,
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          pointerEvents: 'none'
        }}
      >
        <ReactMarkdown>{result}</ReactMarkdown>
      </Typography>
      <Box textAlign="center" my={2}>
        <Button variant="outlined" onClick={onReset}>
          התחל מחדש
        </Button>
      </Box>
    </Box>
  );
};

export default HoroscopeResult; 